import frontend from './frontend';
import backend from './backend';
import each from './each';

export default {
	frontend,
	backend,
	each,
};
